export default __webpack_public_path__ + "static/media/Type E main cover.56048f36.png";